import { BinFileOrderByEnum } from "@admin_api/models/bin-file-order-by-enum";
import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: "app-bin-files-table-cell-content",
    templateUrl: "./bin-files-table-cell-content.component.html",
    styleUrls: ["./bin-files-table-cell-content.component.less"],
    standalone: false
})
export class BinFilesTableCellContentComponent {

    @Input() columnId: string;
    @Input() element: any;
    @Output() download = new EventEmitter<number>();
    @Output() reprocess = new EventEmitter<number>();

    BinFileOrderByEnum = BinFileOrderByEnum;

    constructor() {}

    onClickReprocess() {
        this.reprocess.emit(this.element.id);
    }

    onClickDownload() {
        this.download.emit(this.element.id);
    }

}
